import React, { useState, useEffect } from 'react';
import { AlertCircle, CheckCircle, CircleAlert } from 'lucide-react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import AnalysisSection from './analysis-section';
const DecisionGridList = ({ selectedLOB }) => {
  const [appSummary, setAppSummary] = useState('');
  const [appStatus, setAppStatus] = useState('');

  useEffect(() => {
    // Reset values when selectedLOB changes
    setAppSummary('');
    setAppStatus('');
  }, [selectedLOB]);

  return (
    <>
      <div className='grid grid-cols-3 mb-4 justify-center align-center gap-4'>
        <div className='ml-8'>
          <p className='text-sm text-gray-500 mb-1'>Line of Business:</p>
          <span className=' font-medium'>{selectedLOB}</span>
        </div>
        {/* <div>
          <p className='text-sm text-gray-500 mb-1'>Appetite Status:</p>
          <Badge
            variant='outline'
            className='bg-yellow-50 text-yellow-700 border-yellow-200'
          >
            {appStatus || 'N/A'}
          </Badge>
        </div> */}

        {/* <div>
          <p className='text-sm text-gray-500 mb-1'>Recommendation:</p>
          <Badge
            variant='outline'
            className='bg-green-50 text-green-700 border-green-200'
          >
            {appSummary || 'N/A'}
          </Badge>
        </div> */}
      </div>

      <AnalysisSection
        selectedLob={selectedLOB}
        setAppSummary={setAppSummary}
        setAppStatus={setAppStatus}
      />
    </>
  );
};

export default DecisionGridList;
